<form
  class="form w-100"
  novalidate="novalidate"
  id="kt_sign_in_form"
  [formGroup]="form"
>
  <div class="text-center mb-11">
    <h1 class="text-dark fw-bolder mb-3">Nova Conta</h1>
    <div class="text-gray-700 fw-semibold fs-6">Preencha os dados para criar sua conta</div>
  </div>

  <!-- Tipo de Usuário -->
  <div class="fv-row mb-8">
    <label class="form-label fs-6 fw-bolder text-dark">Tipo de Conta</label>
    <div class="d-flex gap-4 mt-3 flex-column flex-lg-row">
      <div class="form-check form-check-custom form-check-solid w-lg-50 w-100">
        <input
          class="form-check-input"
          type="radio"
          name="userType"
          id="userTypePerson"
          value="person"
          formControlName="userType"
        />
        <label class="form-check-label" for="userTypePerson">
          <span class="fw-bold text-gray-900">Pessoa Física</span>
          <div class="text-gray-700 fs-7">Conta individual</div>
        </label>
      </div>
      <div class="form-check form-check-custom form-check-solid w-lg-50 w-100">
        <input
          class="form-check-input"
          type="radio"
          name="userType"
          id="userTypeCompany"
          value="company"
          formControlName="userType"
        />
        <label class="form-check-label" for="userTypeCompany">
          <span class="fw-bold text-gray-900">Empresa</span>
          <div class="text-gray-700 fs-7">Conta empresarial</div>
        </label>
      </div>
    </div>
  </div>

  <!-- Campo CPF (visível apenas para pessoa física) -->
  <div class="fv-row mb-8" *ngIf="isCpfUser">
    <label class="form-label fs-6 fw-bolder text-dark">CPF</label>
    <input
      type="text"
      autocomplete="off"
      class="form-control bg-transparent"
      formControlName="cpf"
      placeholder="000.000.000-00"
      maxlength="14"
      mask="000.000.000-00"
    />
    <app-field-control-error
      [control]="form.get('cpf')"
      label="CPF"
    ></app-field-control-error>
  </div>

  <!-- Campo CNPJ (visível apenas para empresa) -->
  <div class="fv-row mb-8" *ngIf="isCnpjUser">
    <label class="form-label fs-6 fw-bolder text-dark">CNPJ</label>
    <div class="position-relative">
      <input
        type="text"
        autocomplete="off"
        class="form-control bg-transparent"
        formControlName="cnpj"
        placeholder="00.000.000/0000-00"
        maxlength="18"
        mask="00.000.000/0000-00"
      />
      <div *ngIf="isSearchingCnpj" class="position-absolute top-50 end-0 translate-middle-y me-3">
        <span class="spinner-border spinner-border-sm" role="status"></span>
      </div>
    </div>
    <app-field-control-error
      [control]="form.get('cnpj')"
      label="CNPJ"
    ></app-field-control-error>
  </div>

  <!-- Nome da Empresa (visível apenas para empresa) -->
  <div class="fv-row mb-8" *ngIf="isCnpjUser">
    <label class="form-label fs-6 fw-bolder text-dark">Razão Social</label>
    <input
      type="text"
      autocomplete="off"
      class="form-control bg-transparent"
      formControlName="companyName"
      placeholder="Digite a razão social da empresa"
    />
    <app-field-control-error
      [control]="form.get('companyName')"
      label="Razão Social"
    ></app-field-control-error>
    <!-- <div *ngIf="cnpjCompanyName" class="text-success fs-7 mt-2">
      <i class="bi bi-check-circle me-1"></i>
      Empresa encontrada automaticamente: {{ cnpjCompanyName }}
    </div>
    <div *ngIf="isCnpjUser && !cnpjCompanyName && form.get('cnpj')?.value" class="text-muted fs-7 mt-2">
      <i class="bi bi-info-circle me-1"></i>
      CNPJ não encontrado automaticamente. Digite a razão social manualmente.
    </div> -->
  </div>
  <div class="fv-row mb-8">
    <label class="form-label fs-6 fw-bolder text-dark">
      {{ isCnpjUser ? 'Nome do Responsável' : 'Nome Completo' }}
    </label>
    <input
      type="text"
      autocomplete="off"
      class="form-control bg-transparent"
      formControlName="name"
      [placeholder]="isCnpjUser ? 'Nome do responsável pela conta' : 'Seu nome completo'"
    />
    <app-field-control-error
      [control]="form.get('name')"
      [label]="isCnpjUser ? 'Nome do Responsável' : 'Nome'"
    ></app-field-control-error>
  </div>

  <div class="fv-row mb-8">
    <label class="form-label fs-6 fw-bolder text-dark">Email</label>
    <input
      type="email"
      autocomplete="off"
      class="form-control bg-transparent"
      formControlName="email"
    />
    <app-field-control-error
      [control]="form.get('email')"
      label="E-mail"
    ></app-field-control-error>
  </div>

  <div class="fv-row mb-8">
    <ng-template #popContent>
      Entre 8 e 50 carateres. <br />
      Mínimo de 1 número. <br />
      Mínimo de 1 caractere maiúsculo.
      <br />
      Mínimo de 1 caractere especial.
      <br />
    </ng-template>

    <label class="form-label fs-6 fw-bolder text-dark">Senha</label>
    <input
      type="password"
      autocomplete="off"
      class="form-control bg-transparent"
      formControlName="password"
      triggers="focus"
      placement="top"
      popoverTitle="Requisitos da Senha"
      [ngbPopover]="popContent"
      #p1="ngbPopover"
    />
    <app-field-control-error
      [control]="form.get('password')"
      label="Senha"
    ></app-field-control-error>
  </div>

  <div class="fv-row mb-8">
    <label class="form-label fs-6 fw-bolder text-dark"
      >Confirmação da Senha</label
    >
    <input
      type="password"
      autocomplete="off"
      class="form-control bg-transparent"
      formControlName="retypedPassword"
    />
    <app-field-control-error
      [control]="form.get('retypedPassword')"
      label="Confirmação da senha"
    ></app-field-control-error>
  </div>

  <!-- Termos de Uso -->
  <div class="fv-row mb-8">
    <div class="form-check form-check-custom form-check-solid">
      <input
        class="form-check-input"
        type="checkbox"
        id="termsAccepted"
        formControlName="termsAccepted"
      />
      <label class="form-check-label fs-6 fw-semibold text-gray-700" for="termsAccepted">
        Aceito os
        <a
          href="./assets/files/terms.pdf"
          target="_blank"
          class="link-primary text-decoration-underline"
        >
          Termos de Uso
        </a>
        e condições da plataforma
      </label>
    </div>
    <app-field-control-error
      [control]="form.get('termsAccepted')"
      label="Termos de Uso"
    ></app-field-control-error>
  </div>

  <div class="d-flex flex-stack flex-wrap gap-3 fs-base fw-semibold mb-8">
    <div></div>
  </div>

  <div class="d-grid mb-10">
    <button
      type="submit"
      id="kt_sign_in_submit"
      class="btn btn-primary"
      [disabled]="(loading$ | async) || form.pending"
      (click)="submit()"
    >
      <ng-container *ngIf="loading$ | async">
        <span class="indicator-progress" [style.display]="'block'">
          Aguarde...
          <span
            class="spinner-border spinner-border-sm align-middle ms-2"
          ></span>
        </span>
      </ng-container>
      <ng-container *ngIf="(loading$ | async) === false">
        <span class="indicator-label">Criar Conta</span>
      </ng-container>
    </button>
  </div>
  <div class="text-gray-700 text-center fw-semibold fs-6">
    Já possui uma conta?
    <a [routerLink]="['/auth/login']" class="link-primary">Acessar conta</a>
  </div>
</form>
